import React from "react";

import {Chip, IconButton, Stack} from "@mui/joy";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Grid from "@mui/joy/Grid";
import Box from "@mui/joy/Box";
import Link from "@mui/joy/Link";

// components
import CommonEditModal from "./CommonEditModal";
import {generatePath} from "react-router-dom";
import CommonCopyToClipboard from "./CommonCopyToClipboard";
import DownloadIcon from '@mui/icons-material/Download';
import BaseApi from "../../utils/BaseApi";
import {b64toBlob, downloadBlob} from "../../utils/misc";


class CommonInfoTab extends React.Component {
    async download(objUrl, objId, field){
        const api = new BaseApi();
        const url = `${objUrl}/${objId}/file_field_download/`;
        let params = {
            field: field
        }
        let response = await api.get(
            url,
            params
        );
        downloadBlob(
            b64toBlob(response.data.file),
            response.data.filename,
            response.data.mime_type
        )
    }

    render() {
        return(
            <Stack
                spacing={2}
            >
                {this.props.groups.map((group) => (
                    <Card
                        size={'sm'}
                        variant={'plain'}
                        sx={{
                            border: this.props.flat?0:null,
                            p: this.props.flat?0:null,
                            backgroundColor: this.props.flat?'rgba(0,0,0,0)':null
                        }}
                    >
                        <CardContent>
                            {
                                (group.title || group.icon || group.actions)?
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Stack
                                            direction={'row'}
                                            spacing={1}
                                            sx={{
                                                pb: 2
                                            }}
                                            alignItems="center"
                                        >
                                            {
                                                group.icon?
                                                    group.icon:
                                                    null
                                            }
                                            <Typography level="title-md">
                                                {
                                                    group.linkPattern?
                                                        <Link
                                                            href={
                                                                group.linkPattern&&group.linkParam?generatePath(group.linkPattern, { linkParam: group.linkParam}):null
                                                            }
                                                            sx={{
                                                                zIndex: 1005
                                                            }}
                                                        >
                                                            {group.title}
                                                        </Link>:
                                                        group.title
                                                }
                                            </Typography>
                                            {
                                                group.edit && group.edit.permission?
                                                    <CommonEditModal
                                                        fields={group.edit.fields}
                                                        m2mFields={group.edit.m2mFields}
                                                        baseUrl={group.edit.baseUrl}
                                                        obj={group.edit.obj}
                                                        callBack={group.edit.callBack?group.edit.callBack:this.props.callBack}
                                                        buttonIconOnly={true}
                                                        fieldUpdates={group.edit.fieldUpdates}
                                                    />:
                                                    null
                                            }
                                        </Stack>
                                        <Stack
                                            direction={'row'}
                                            spacing={2}
                                            sx={{
                                                pb: 2
                                            }}
                                        >
                                            {
                                                group.extraComponents?
                                                    <>
                                                        {
                                                           group.extraComponents.map((c)=>(
                                                                <c.component
                                                                    {...c.componentProps}
                                                                    callBack={c.callBack?c.callBack:this.props.callBack}
                                                                />
                                                            ))
                                                        }
                                                    </>
                                                    :null
                                            }
                                        </Stack>
                                    </Stack>:
                                    null
                            }
                            <Grid
                                container={true}
                                spacing={group.flat?1:2}
                                sx={{
                                    flexGrow: 1
                                }}
                            >

                                {group.components?.map((component) => (
                                    <Grid
                                        xs={12}

                                    >
                                        <component.component
                                            {...component.componentProps}
                                        />
                                    </Grid>
                                ))}
                                {group.fields?.map((field) => {
                                    if (field && !field.hide){
                                        return(
                                            <Grid
                                                xs={field.xs?field.xs:12}
                                                sm={field.sm?field.sm:12}
                                                md={field.md?field.md:6}
                                                lg={field.lg?field.lg:6}
                                                sx={{
                                                    position: 'relative',
                                                }}
                                            >

                                            <Card
                                                size={'sm'}
                                                variant={field.flat?null:'soft'}
                                                sx={{
                                                    border: field.flat?0:null,
                                                    p: field.flat?0:null,
                                                    backgroundColor: field.flat?'rgba(0,0,0,0)':null,
                                                    gap: '0.25rem',
                                                }}
                                            >
                                                <Typography
                                                    level="body-xs"
                                                >
                                                    {field.title}
                                                </Typography>
                                                {
                                                    field.component?
                                                        <>
                                                            <field.component.component
                                                                {...field.component.props}
                                                            />
                                                        </>:
                                                        <Stack
                                                            direction={'row'}
                                                            spacing={1}
                                                            alignItems="center"
                                                        >
                                                            {
                                                                field.value === null || field.value === '' || field.value?.length === 0 ?
                                                                <Chip
                                                                    color="warning"
                                                                >
                                                                    Не указано
                                                                </Chip>:
                                                                    Array.isArray(field.value)?
                                                                        <Stack
                                                                            direction={'row'}
                                                                            spacing={1}
                                                                            useFlexGap
                                                                            sx={{
                                                                                flexWrap: 'wrap',
                                                                                width: '100%'
                                                                            }}
                                                                        >
                                                                            {field.value.map((v) => (
                                                                                <Chip
                                                                                    color={'primary'}
                                                                                    sx={{
                                                                                        maxWidth: '100%',
                                                                                    }}
                                                                                >
                                                                                    {v[field.fieldFromArray]}
                                                                                </Chip>
                                                                            ))}
                                                                        </Stack>:
                                                                        <Box>
                                                                            {
                                                                                field.html?
                                                                                    <div dangerouslySetInnerHTML={{__html: field.value}} />:
                                                                                    field.linkPattern?
                                                                                        <Link
                                                                                            href={
                                                                                                field.linkPattern&&field.linkParam?generatePath(field.linkPattern, { linkParam: field.linkParam}):field.linkPattern?field.linkPattern:null
                                                                                            }
                                                                                            sx={{
                                                                                                zIndex: 1005
                                                                                            }}
                                                                                            target={field.linkTarget?field.linkTarget:null}
                                                                                        >
                                                                                            {field.value}
                                                                                        </Link>:
                                                                                            typeof field.value === 'boolean'?
                                                                                                field.value?<Chip color="success">Да</Chip>:<Chip color="danger">Нет</Chip>:
                                                                                                <Stack>
                                                                                                    {field.value}
                                                                                                </Stack>
                                                                            }
                                                                        </Box>
                                                            }
                                                            {
                                                                field.edit && field.edit.permission?
                                                                    <CommonEditModal
                                                                        overlay={true}
                                                                        fields={field.edit.fields}
                                                                        m2mFields={field.edit.m2mFields}
                                                                        baseUrl={field.edit.baseUrl}
                                                                        obj={field.edit.obj}
                                                                        callBack={field.edit.callBack?field.edit.callBack:this.props.callBack}
                                                                        buttonIconOnly={true}
                                                                        fieldUpdates={field.edit.fieldUpdates}
                                                                    />:
                                                                    null
                                                            }
                                                            {
                                                                field.copy?
                                                                    <CommonCopyToClipboard
                                                                        content={field.value}
                                                                    />:
                                                                    null
                                                            }
                                                            {
                                                                field.file?.url && field.file?.id && field.value?
                                                                    <IconButton
                                                                        onClick={() => {this.download(
                                                                            field.file.url,
                                                                            field.file.id,
                                                                            field.file.field,
                                                                        )}}
                                                                    >
                                                                        <DownloadIcon />
                                                                    </IconButton>
                                                                    :null
                                                            }
                                                            {
                                                                field.extraComponents?
                                                                    <>
                                                                        {
                                                                            field.extraComponents.map((c)=>(
                                                                                <c.component
                                                                                    {...c.componentProps}
                                                                                    callBack={c.callBack?c.callBack:this.props.callBack}
                                                                                />
                                                                            ))
                                                                        }
                                                                    </>
                                                                    :null
                                                            }
                                                        </Stack>
                                                }
                                            </Card>
                                        </Grid>
                                    )}
                                })}
                            </Grid>
                        </CardContent>
                    </Card>
                ))}
            </Stack>
        )
    }
}

export default CommonInfoTab;
